import React, { useState } from "react";
import SearchWrapper from "./searchWrapper";
var Search = function (_a) {
    var onClose = _a.onClose, edges = _a.posts;
    var _b = useState([]), posts = _b[0], setPosts = _b[1];
    var findPosts = function (value) {
        var matchPosts = edges.filter(function (_a) {
            var node = _a.node;
            var title = node.frontmatter.title;
            return title.toLowerCase().startsWith(value.toLowerCase());
        });
        value.length ? setPosts(matchPosts) : setPosts([]);
    };
    return (React.createElement(SearchWrapper, { posts: posts, onSearchChange: findPosts, onClose: onClose }));
};
export default Search;
